import { Component, Input, OnInit, TemplateRef, OnDestroy } from '@angular/core';
import { EnvironmentService } from 'projects/shared/services/environment.service';

@Component({
    selector: 'user-account-template',
    templateUrl: 'user-account-template.component.html',
    standalone: false
})

export class UserAccountTemplateComponent implements OnInit, OnDestroy {

  @Input()
  contentTemplate!: TemplateRef<any>;

  private fallbackImage = '../../../assets/images/login-background-2.jpg';

  constructor(private environmentService: EnvironmentService) {
    const imageUrl = this.environmentService.borrowerPortalLoginImageUrl;
    this.setBackgroundStyles();

    // Preload the image to detect load failures and apply fallback
    const img = new Image();
    img.onload = () => {
      document.body.style.backgroundImage = `url('${imageUrl}')`;
    };
    img.onerror = () => {
      document.body.style.backgroundImage = `url('${this.fallbackImage}')`;
    };
    img.src = imageUrl;
  }

  ngOnInit() { }

  ngOnDestroy(){
    document.body.style.backgroundImage = "";
    document.body.style.backgroundSize = "";
    document.body.style.backgroundPosition = "";
  }

  private setBackgroundStyles() {
    document.body.style.backgroundSize = "cover";
    document.body.style.backgroundPosition = "center left";
  }
}
